export default __webpack_public_path__ + "static/heroBg-ea9cbe80ec2ea30754507f70b4a1894e.png";